const moment = require('moment-timezone');

function determineStatus(campaigns) {
	// 1) get all campaigns for a specific state
	const cache = {
		wa: null,
		nt: null,
		sa: null,
		qld: null,
		nsw: null,
		vic: null,
		tas: null,
		act: null,
	};

	const expiredCache = {};

	const timezones = {
		wa: 'Australia/Perth',
		nt: 'Australia/Darwin',
		sa: 'Australia/Adelaide',
		qld: 'Australia/Brisbane',
		nsw: 'Australia/Sydney',
		vic: 'Australia/Melbourne',
		tas: 'Australia/Hobart',
		act: 'Australia/Melbourne',
	};

	// 2) determine if it's live based on date
	campaigns.forEach((campaign) => {
		campaign.states.forEach((state) => {
			const currentDate = moment(moment().tz(timezones[state]).format('YYYY-MM-DDTHH:mm:ss')).toDate();
			const startDate = moment(moment(campaign.startDate).utc(true).format('YYYY-MM-DDTHH:mm:ss')).toDate();
			const endDate = moment(moment(campaign.endDate).utc(true).format('YYYY-MM-DDTHH:mm:ss')).toDate();
			const isLive = startDate <= currentDate && endDate > currentDate && campaign.status === 'approved';
			const isExpired = currentDate > endDate;
			if (isLive && !cache[state]) cache[state] = campaign.id;
			if (isExpired) expiredCache[campaign.id] = true;
		});
	});

	// 3) if none are live then find isDefault
	campaigns.forEach((campaign) => {
		if (campaign.isDefault) {
			campaign.states.forEach((state) => {
				if (!cache[state]) cache[state] = campaign.id;
			});
		}
	});
	const modifiedCampaigns = campaigns
    // 4) set isLive if campaigns are on the live cache
		.map((campaign) => {
			const liveIds = Object.values(cache);
			return {
				model: campaign,
				isLive: liveIds.indexOf(campaign.id) > -1,
			};
		})
    // 4) set isExpired if campaigns are on the expired cache
		.map((campaign) => {
			return Object.assign(campaign, { isExpired: expiredCache[campaign.model.id] });
		});

	return modifiedCampaigns;
}

module.exports = {
    determineStatus,
};




//////////////////
// WEBPACK FOOTER
// ./lib/utils.js
// module id = 274
// module chunks = 0